module.exports = __webpack_public_path__ + "static/media/SearchTerms.141fd3ee.svg";